import { NAZIVI_STANJA, NAZIVI_VEZE, STATUSI } from './konstante.js';

const POLJA = {
  naselje: 'Naselje', kucni_broj: 'Kućni broj', opis_lokacije: 'Opis lokacije',
  nositelj_ime: 'Ime nositelja', nositelj_prezime: 'Prezime nositelja',
  broj_prikljucaka: 'Broj priključaka', godina_prikljucenja: 'Godina priključenja',
  stanje: 'Stanje kućanstva', status_tocke: 'Status lokacije', lokacija: 'Koordinate',
  tocnost_m: 'Točnost lokacije (m)', napomena: 'Napomena', izvor: 'Izvor',
  stari_clan_id: 'Veza na stari popis', ime: 'Ime kontakta', prezime: 'Prezime kontakta',
  veza: 'Veza s nositeljem', telefon: 'Telefon', email: 'E-mail',
  glavni: 'Glavni kontakt', telefon_nositelja: 'Telefon pripada nositelju',
};

export function vrijemePromjene(vrijeme) {
  if (!vrijeme || !Number.isFinite(Date.parse(vrijeme))) return 'Vrijeme nije zabilježeno';
  return new Intl.DateTimeFormat('hr-HR', {
    dateStyle: 'medium', timeStyle: 'short', timeZone: 'Europe/Zagreb',
  }).format(new Date(vrijeme));
}

function prikazVrijednosti(kljuc, v) {
  if (v == null || v === '') return 'Nije upisano';
  if (typeof v === 'boolean') return v ? 'Da' : 'Ne';
  if (kljuc === 'lokacija') return `${Number(v.lat).toFixed(6)}, ${Number(v.lng).toFixed(6)}`;
  if (kljuc === 'stanje') return NAZIVI_STANJA[v] ?? String(v);
  if (kljuc === 'status_tocke') return STATUSI[v]?.naziv ?? String(v);
  if (kljuc === 'veza') return NAZIVI_VEZE[v] ?? String(v);
  if (kljuc === 'izvor') return v === 'uvoz' ? 'Uvoz' : 'Terenski unos';
  return String(v);
}

/** Samo poslovna polja; usporedba lokacije ne ovisi o poretku JSON ključeva. */
export function razlikeZapisa(prije, poslije) {
  return Object.entries(POLJA).flatMap(([kljuc, naziv]) => {
    const stara = prikazVrijednosti(kljuc, prije?.[kljuc]);
    const nova = prikazVrijednosti(kljuc, poslije?.[kljuc]);
    return stara === nova ? [] : [{ kljuc, naziv, prije: stara, poslije: nova }];
  });
}

/** Jedno spremanje može promijeniti kućanstvo i više kontakata. */
export function grupirajPovijest(zapisi) {
  const grupe = new Map();
  for (const z of zapisi) {
    const kljuc = `${z.transakcija}:${z.korisnik_id ?? 'sustav'}`;
    if (!grupe.has(kljuc)) grupe.set(kljuc, {
      kljuc, korisnik: z.korisnik_naziv, vrijeme: z.vrijeme, zapisi: [],
    });
    const grupa = grupe.get(kljuc);
    grupa.zapisi.push(z);
    if (z.vrijeme > grupa.vrijeme) grupa.vrijeme = z.vrijeme;
  }
  return [...grupe.values()];
}

export function naslovPromjene(z) {
  const kontakt = z.entitet === 'kontakt';
  const podaci = z.poslije ?? z.prije;
  const naziv = kontakt ? `kontakt: ${[podaci?.ime, podaci?.prezime].filter(Boolean).join(' ')}` : 'kućanstvo';
  const glagol = z.radnja === 'unos' ? (kontakt ? 'Dodan' : 'Dodano')
    : z.radnja === 'brisanje' ? (kontakt ? 'Uklonjen' : 'Uklonjeno') : (kontakt ? 'Izmijenjen' : 'Izmijenjeno');
  return `${glagol} ${naziv}`;
}
